module.exports = __webpack_public_path__ + "img/gastos_1.b121d08c.png";